/* global ally */

// Add forEach method to nodeLists
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function(callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// Use ally.js to handle focus-within on product tiles.
var handle = ally.style.focusWithin();
